const clearWorkflow = ({ commit }) => {
  commit('SET_AUTOMATION_WORKFLOW', null);
  commit('SET_WORKFLOW_SELECT_VERSION', null);
  commit('SET_SELECTED_NODE', null);
  commit('SET_START_SETTINGS', {
    period: null,
    time_at: null,
    day: null,
    week: [],
    custom: null,
    trigger_subtype: null,
    trigger_type: 'manual',
  });
  commit('WORKFLOW_EDITED', false);
  commit('SET_NODES', []);
  commit('SET_CREDENTIALS', []);
};

export default clearWorkflow;
